import createIcon from '@/lib/create-icon'
import React from 'react'

export const EmptyLogoIcon = createIcon(
  <svg
    width="171"
    height="54"
    viewBox="0 0 171 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_16120_284489)">
      <rect
        x="0.949219"
        y="0.126831"
        width="169.6"
        height="53"
        rx="7.95"
        fill="black"
        fillOpacity="0.03"
      />
      <path
        d="M32.4954 31.2518V28.5912L29.909 24.0438H31.0008L32.6862 27.0436L33.0148 27.7326L33.3328 27.0436L35.0182 24.0438H36.057L33.4706 28.5912V31.2518H32.4954ZM39.708 31.379C37.5986 31.379 36.3054 29.9586 36.3054 27.6584C36.3054 25.3582 37.5986 23.9166 39.708 23.9166C41.8068 23.9166 43.1106 25.3582 43.1106 27.6584C43.1106 29.9586 41.8068 31.379 39.708 31.379ZM39.708 30.5416C41.2132 30.5416 42.1142 29.4498 42.1142 27.6584C42.1142 25.8564 41.2132 24.754 39.708 24.754C38.2028 24.754 37.3018 25.8564 37.3018 27.6584C37.3018 29.4498 38.2028 30.5416 39.708 30.5416ZM50.1707 28.5064C50.1707 30.2872 49.0683 31.379 47.2981 31.379C45.5173 31.379 44.4149 30.2872 44.4149 28.5064V24.0438H45.4007V28.5064C45.4007 29.8102 46.1109 30.5946 47.2981 30.5946C48.4853 30.5946 49.1955 29.7996 49.1955 28.5064V24.0438H50.1707V28.5064ZM51.7354 31.2518V24.0438H54.3324C55.8482 24.0438 56.8128 24.8282 56.8128 26.079C56.8128 26.9058 56.41 27.4888 55.7316 27.7962C56.198 28.0082 56.4418 28.4004 56.622 29.1106L57.1626 31.2518H56.1344L55.6786 29.3014C55.4666 28.4004 55.1062 28.2308 54.237 28.2308H52.7106V31.2518H51.7354ZM54.3112 24.8388H52.7106V27.4358H54.29C55.244 27.4358 55.8058 26.927 55.8058 26.132C55.8058 25.337 55.244 24.8388 54.3112 24.8388ZM66.3874 26.1214H65.3698C65.1048 25.2416 64.3522 24.754 63.43 24.754C62.0202 24.754 61.1828 25.8564 61.1828 27.6584C61.1828 29.4604 62.0096 30.5416 63.43 30.5416C64.3204 30.5416 65.0412 30.0858 65.3486 29.2166H66.3768C65.974 30.584 64.7974 31.379 63.4194 31.379C61.4054 31.379 60.1864 29.9692 60.1864 27.6584C60.1864 25.3582 61.4266 23.9166 63.4618 23.9166C64.8504 23.9166 66.0376 24.6798 66.3874 26.1214ZM70.804 31.379C68.6946 31.379 67.4014 29.9586 67.4014 27.6584C67.4014 25.3582 68.6946 23.9166 70.804 23.9166C72.9028 23.9166 74.2067 25.3582 74.2067 27.6584C74.2067 29.9586 72.9028 31.379 70.804 31.379ZM70.804 30.5416C72.3092 30.5416 73.2102 29.4498 73.2102 27.6584C73.2102 25.8564 72.3092 24.754 70.804 24.754C69.2988 24.754 68.3978 25.8564 68.3978 27.6584C68.3978 29.4498 69.2988 30.5416 70.804 30.5416ZM75.5957 31.2518V24.0438H76.9419L79.1573 29.3332L79.3693 29.9798L79.5919 29.3332L81.7967 24.0438H83.1005V31.2518H82.1253V25.2204L81.6165 26.6408L79.6873 31.2518H78.9983L77.0691 26.6302L76.5709 25.2522V31.2518H75.5957ZM84.7569 31.2518V24.0438H87.2267C88.8591 24.0438 89.8873 24.913 89.8873 26.3228C89.8873 27.775 88.8485 28.623 87.2373 28.623H85.7321V31.2518H84.7569ZM87.2161 24.8388H85.7321V27.828H87.1843C88.2549 27.828 88.8803 27.2556 88.8803 26.3334C88.8803 25.4218 88.2443 24.8388 87.2161 24.8388ZM95.6642 31.2518L94.9858 29.524H91.5302L90.8518 31.2518H89.8872L92.7174 24.0438H93.841L96.6818 31.2518H95.6642ZM93.046 25.6232L91.827 28.7396H94.689L93.47 25.6232L93.258 24.9872L93.046 25.6232ZM97.717 31.2518V24.0438H98.7346L102.052 29.1318L102.466 29.842V24.0438H103.441V31.2518H102.423L99.1162 26.1956L98.6922 25.4536V31.2518H97.717ZM107.016 31.2518V28.5912L104.43 24.0438H105.522L107.207 27.0436L107.536 27.7326L107.854 27.0436L109.539 24.0438H110.578L107.991 28.5912V31.2518H107.016ZM113.482 31.2518V24.0438H114.458V30.4568H118.083V31.2518H113.482ZM122.013 31.379C119.904 31.379 118.611 29.9586 118.611 27.6584C118.611 25.3582 119.904 23.9166 122.013 23.9166C124.112 23.9166 125.416 25.3582 125.416 27.6584C125.416 29.9586 124.112 31.379 122.013 31.379ZM122.013 30.5416C123.518 30.5416 124.419 29.4498 124.419 27.6584C124.419 25.8564 123.518 24.754 122.013 24.754C120.508 24.754 119.607 25.8564 119.607 27.6584C119.607 29.4498 120.508 30.5416 122.013 30.5416ZM132.73 31.2518H131.999L131.925 30.1176C131.48 30.9762 130.685 31.379 129.731 31.379C127.78 31.379 126.54 29.9692 126.54 27.6584C126.54 25.3582 127.78 23.9166 129.815 23.9166C131.204 23.9166 132.391 24.6798 132.741 26.1214H131.723C131.458 25.2416 130.706 24.754 129.784 24.754C128.374 24.754 127.536 25.8564 127.536 27.6584C127.536 29.4604 128.384 30.5416 129.815 30.5416C130.886 30.5416 131.734 29.8844 131.798 28.3368H129.953V27.563H132.73V31.2518ZM137.375 31.379C135.266 31.379 133.972 29.9586 133.972 27.6584C133.972 25.3582 135.266 23.9166 137.375 23.9166C139.474 23.9166 140.778 25.3582 140.778 27.6584C140.778 29.9586 139.474 31.379 137.375 31.379ZM137.375 30.5416C138.88 30.5416 139.781 29.4498 139.781 27.6584C139.781 25.8564 138.88 24.754 137.375 24.754C135.87 24.754 134.969 25.8564 134.969 27.6584C134.969 29.4498 135.87 30.5416 137.375 30.5416Z"
        fill="black"
        fillOpacity="0.3"
      />
      <line
        x1="-50.2967"
        y1="106.887"
        x2="110.691"
        y2="-54.1009"
        stroke="black"
        strokeOpacity="0.1"
        strokeWidth="0.6625"
      />
      <line
        x1="-39.6952"
        y1="106.887"
        x2="121.292"
        y2="-54.1008"
        stroke="black"
        strokeOpacity="0.1"
        strokeWidth="0.6625"
      />
      <line
        x1="-29.0975"
        y1="106.887"
        x2="131.89"
        y2="-54.1008"
        stroke="black"
        strokeOpacity="0.1"
        strokeWidth="0.6625"
      />
      <line
        x1="-18.4959"
        y1="106.887"
        x2="142.492"
        y2="-54.1008"
        stroke="black"
        strokeOpacity="0.1"
        strokeWidth="0.6625"
      />
      <line
        x1="-7.89829"
        y1="106.887"
        x2="153.089"
        y2="-54.1008"
        stroke="black"
        strokeOpacity="0.1"
        strokeWidth="0.6625"
      />
      <line
        x1="2.70327"
        y1="106.887"
        x2="163.691"
        y2="-54.1009"
        stroke="black"
        strokeOpacity="0.1"
        strokeWidth="0.6625"
      />
      <line
        x1="13.3048"
        y1="106.887"
        x2="174.292"
        y2="-54.1008"
        stroke="black"
        strokeOpacity="0.1"
        strokeWidth="0.6625"
      />
      <line
        x1="23.9025"
        y1="106.887"
        x2="184.89"
        y2="-54.1008"
        stroke="black"
        strokeOpacity="0.1"
        strokeWidth="0.6625"
      />
      <line
        x1="34.5041"
        y1="106.887"
        x2="195.492"
        y2="-54.1008"
        stroke="black"
        strokeOpacity="0.1"
        strokeWidth="0.6625"
      />
      <line
        x1="45.1017"
        y1="106.887"
        x2="206.089"
        y2="-54.1008"
        stroke="black"
        strokeOpacity="0.1"
        strokeWidth="0.6625"
      />
      <line
        x1="55.7033"
        y1="106.887"
        x2="216.691"
        y2="-54.1009"
        stroke="black"
        strokeOpacity="0.1"
        strokeWidth="0.6625"
      />
      <line
        x1="66.3048"
        y1="106.887"
        x2="227.292"
        y2="-54.1008"
        stroke="black"
        strokeOpacity="0.1"
        strokeWidth="0.6625"
      />
      <line
        x1="76.9025"
        y1="106.887"
        x2="237.89"
        y2="-54.1008"
        stroke="black"
        strokeOpacity="0.1"
        strokeWidth="0.6625"
      />
      <line
        x1="87.5041"
        y1="106.887"
        x2="248.492"
        y2="-54.1008"
        stroke="black"
        strokeOpacity="0.1"
        strokeWidth="0.6625"
      />
      <line
        x1="98.1017"
        y1="106.887"
        x2="259.089"
        y2="-54.1008"
        stroke="black"
        strokeOpacity="0.1"
        strokeWidth="0.6625"
      />
      <line
        x1="108.703"
        y1="106.887"
        x2="269.691"
        y2="-54.1009"
        stroke="black"
        strokeOpacity="0.1"
        strokeWidth="0.6625"
      />
      <line
        x1="-103.297"
        y1="106.887"
        x2="57.6908"
        y2="-54.1009"
        stroke="black"
        strokeOpacity="0.1"
        strokeWidth="0.6625"
      />
      <line
        x1="-92.6952"
        y1="106.887"
        x2="68.2923"
        y2="-54.1008"
        stroke="black"
        strokeOpacity="0.1"
        strokeWidth="0.6625"
      />
      <line
        x1="-82.0975"
        y1="106.887"
        x2="78.89"
        y2="-54.1008"
        stroke="black"
        strokeOpacity="0.1"
        strokeWidth="0.6625"
      />
      <line
        x1="-71.4959"
        y1="106.887"
        x2="89.4916"
        y2="-54.1008"
        stroke="black"
        strokeOpacity="0.1"
        strokeWidth="0.6625"
      />
      <line
        x1="-60.8983"
        y1="106.887"
        x2="100.089"
        y2="-54.1008"
        stroke="black"
        strokeOpacity="0.1"
        strokeWidth="0.6625"
      />
    </g>
    <rect
      x="1.28047"
      y="0.458081"
      width="168.938"
      height="52.3375"
      rx="7.61875"
      stroke="black"
      strokeOpacity="0.1"
      strokeWidth="0.6625"
    />
    <defs>
      <clipPath id="clip0_16120_284489">
        <rect
          x="0.949219"
          y="0.126831"
          width="169.6"
          height="53"
          rx="7.95"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>,
)
